export class Software {
    public id: string;
    public name: string;
    public category: string;
    public softwareType: string;
    public version: string;
    public label: string;
    public value: string;
}